import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from 'components/Link'
import { Eyebrow, Title26 } from 'components/Typography'
import { isTablet } from 'react-device-detect'
import { getBGColor } from 'utils/themeUtils'

const imgRatio = (9 / 16) * 100

export const Wrapper = styled.div`
  border: 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  ${(props) =>
    props.isOffer &&
    `width: auto;

    @media screen and (max-width: ${props.theme.breakpoints.sm}) {
      width: 100%;
    }
  `}
`

export const WrapperLink = styled(Link)`
  border: 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  ${(props) =>
    props.isOffer &&
    `width: auto;

    @media screen and (max-width: ${props.theme.breakpoints.sm}) {
      width: 100%;
    }
  `}
`

export const CardOverlay = styled.div`
  background-color: black;
  height: 100%;
  opacity: 0.35;
  position: absolute;
  width: 100%;
  z-index: 1;
`

const cardMetaStyle = `
  position: relative;

  ${(props) => props.isSmall && `background: white;`}

  html[dir='ltr'] {
    padding-right: ${({ theme }) => theme.space[2]};
  }

  html[dir='rtl'] {
    padding-left: ${({ theme }) => theme.space[2]};
  }
`

export const CardMeta = styled.div`
  ${cardMetaStyle}
`

export const CardMetaDivider = styled.span`
  display: inline-block;
  margin: 0 ${({ theme }) => theme.space[1]};
`

export const CardImg = styled(GatsbyImage)`
  background-color: black;
  height: 150vw;
  max-height: 540px;
  width: 100%;

  img {
    opacity: 0.65 !important;
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    ${(props) => props.isSmall && `max-height: 350px;`}
  }
`

export const ProductCardImg = styled(GatsbyImage)`
  height: 150vw;
  max-height: 540px;
  width: 100%;

  img {
    background-color: white;
    object-fit: cover;
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    ${(props) => props.isSmall && `max-height: 350px;`}
  }
`

export const ProductCardInfoWrapper = styled.div`
  padding: 0 0 0;
`

export const CardImgWrapper = styled.div`
  display: block;
  height: 100vw;
  max-height: 250px;
  position: relative;
  width: 100%;

  .gatsby-image-wrapper {
    height: 100% !important;
  }

  ::after {
    background: rgba(69, 69, 69, 0.2);
    content: '';
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

export const CardImgCopy = styled.div`
  bottom: 0;
  color: white;
  left: 0;
  padding: ${({ theme }) => theme.space[5]};
  position: absolute;
  right: 0;
  text-align: center;
  z-index: 1;

  h5 {
    color: ${({ theme }) => theme.colors.sagefeather};
  }
`

export const CardServiceMeta = styled.div`
  ${cardMetaStyle}
  background-color: ${getBGColor()};
  padding: ${({ theme }) => theme.space[5]};
  text-align: center;
  height: 100%;

  p {
    color: ${(props) => props.theme.colors.sagemedium};
  }

  strong {
    color: ${(props) => props.theme.colors.sagedarkToblack};
    font-weight: normal;
  }
`

export const CardInfoMeta = styled.div`
  ${cardMetaStyle}
  background-color: ${({ background, theme }) =>
    background === 'Green'
      ? theme.colors.sagedarkToGreen
      : theme.colors.mushroomGrey};
  height: 100vw;
  max-height: 300px;
  padding: ${({ theme }) => theme.space[5]} ${({ theme }) =>
  theme.space[5]} ${({ theme }) => theme.space[12]};
  text-align: center;

  h5,
  p {
    color: ${({ background, theme }) =>
      background === 'Green'
        ? theme.colors.sagedarkToSandstone
        : theme.colors.coaldarkToBlack};
  }

  p {
    margin: ${({ theme }) => theme.space[5]} 0;
  }
`

export const ServiceCardImgWrapper = styled.div`
  height: 0;
  padding-bottom: ${imgRatio}%;
  position: relative;
  width: 100%;
  overflow: hidden;

  > div {
    position: absolute !important;
  }

  &::after {
    background: rgba(69, 69, 69, 0.35);
    content: '';
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

export const ServiceCardImg = styled(GatsbyImage)`
  height: 100%;
  width: 100%;
`

export const BrandCardContainer = styled.div`
  width: 100%;

  ${(props) =>
    props.hasImage &&
    `
    * {
      color: white;
    }
  `}

  ${({ theme }) => theme.mediaQueries.large} {
    width: 295px;
  }
`

export const BrandCardImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 360px;
  overflow: hidden;

  ${({ theme }) => theme.mediaQueries.large} {
    width: 295px;
  }
`

export const BrandCardImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;

  ::after {
    content: '';
    width: 100%;
    height: 100%;
    background-color: rgba(27, 27, 27, 0.2);
    top: 0;
    left: 0;
    position: absolute;
    display: block;
  }
`

export const BrandCardEyebrow = styled(Eyebrow)`
  line-height: 12px;
  margin-bottom: 10px;
`

export const BrandCardContent = styled.div`
  padding: 20px;
  margin-bottom: 70px;
`

export const BrandCardSummary = styled(Title26)`
  font-size: 26px;
  letter-spacing: -1.2px;
  line-height: 36px;
`

export const BrandCardLogo = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;

  svg {
    margin: 0 20%;
    width: 100%;
    height: auto;

    * {
      fill: white;
    }
  }
`

export const CardModalButton = styled.div`
  display: block;
  background-color: ${getBGColor()};
  padding: 2px 4px;
  border-radius: 100px;
  position: absolute;
  right: ${({ theme }) => theme.space[6]};
  top: ${({ theme }) => theme.space[2]};
  z-index: 1;

  ${({ theme }) => theme.mediaQueries.medium} {
    display: ${isTablet ? 'block' : 'none'};
  }

  ${({ theme }) => theme.mediaQueries.ipad_landscape} {
    display: block;
  }
`

export const ProductCardWrapper = styled.div`
  ${({ theme }) => theme.mediaQueries.medium} {
    &:hover {
      cursor: pointer;
    }
    &:hover ${CardModalButton} {
      display: block;
      position: absolute;
      right: ${({ theme }) => theme.space[2]};
      top: ${({ theme }) => theme.space[2]};
      z-index: 1;
    }
  }
`
